import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Col } from "antd";
import { ErrorMessage } from "formik";
import styled from "styled-components";
import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import TextField from "@/common/elements/InputElements/TextField";
import FormItem from "@/common/elements/InputElements/FormItem.jsx/index.jsx";
import Select from "@/common/elements/InputElements/Select";
import CommonDatePicker from "@/common/elements/DatePicker";
import { StyledDate } from "@/components/InmateDetails/styles";
import {
  getSQLTypeToHTMLType,
  getOptionsFromRefList,
  findAgefromDOB,
  generateRules,
  isNonEmptyVariable,
} from "@/util/common_function";
import { StyledFlex } from "../styles";
import Checkbox from "../elements/InputElements/CheckBox";
import { useSelector } from "react-redux";
import { PERSON } from "@/components/InmateDetails/Personal";

const StyledColumn = styled(Col)`
  .ant-col {
    min-height: auto !important;
  }
`;

const DynamicForm = ({
  formAttributes,
  i,
  form,
  person,
  bookingsFieldsEnabled = true,
  view = true,
  edit = true,
  fullSearch = false,
}) => {
  const { isScheduledBooking } = useSelector((state) => state?.bookings);
  const {
    label,
    columnName,
    tableName,
    type,
    refListName,
    isID,
    isStaff,
    disabled,
    canSelectFutureDate = false,
    disablePastDate = false,
    showSearch = false,
    longStringRequired = formAttributes.longStringRequired ||
      ["teeth", "hairStyle"].includes(columnName),
    maxLength = -1,
  } = formAttributes;
  const htmlType = getSQLTypeToHTMLType(type);

  const newColumnName = Array.isArray(columnName)
    ? columnName[columnName?.length - 1]
    : columnName;
  let paramContext = tableName + ":" + newColumnName;

  const isAgencyInmate = columnName == "agency" && person == "INMATE";

  const [isScheduledBookingLocal, setisScheduledBookingLocal] = useState(false);

  useEffect(() => {
    if (["Last Name", "First Name"]?.findIndex((d) => d === label) !== -1) {
      setisScheduledBookingLocal(() => false);
    } else {
      setisScheduledBookingLocal(() => isScheduledBooking);
    }
  }, [label, isScheduledBooking]);

  if (person === PERSON.STAFF || person === PERSON.VISITOR_LOG) {
    if (["Race", "Gender", "DOB"]?.findIndex((d) => d === label) !== -1) {
      paramContext = "";
    }
  }

  return (
    <React.Fragment>
      {
        // checkField(paramContext) &&
        <StyledColumn key={i} span={24 / 4}>
          {(htmlType === "text" || htmlType === "number") && (
            <>
              <FormItem
                name={columnName}
                label={label}
                rules={
                  !fullSearch 
                    ? (
                        !isScheduledBookingLocal 
                          ? generateRules(paramContext, label, !isAgencyInmate)
                          : []
                      )
                    : []
                }
              >
                <TextField
                  type={htmlType}
                  placeholder={label}
                  disabled={!fullSearch ? disabled || !edit || !bookingsFieldsEnabled : false}
                  style={
                    view
                      ? {}
                      : {
                          background: "#c2cad0",
                          "font-size": "0px",
                          "min-height": "31px",
                          height: "100%",
                          "pointer-events": "none",
                        }
                  }
                  className={view ? "" : "input-control-mask"}
                  maxLength={maxLength !== -1 ? maxLength : ""}
                />
              </FormItem>
            </>
          )}
          {htmlType === "textarea" && (
            <>
              <FormItem
                name={columnName}
                label={label}
                rules={
                  !fullSearch 
                    ? (
                        !isScheduledBookingLocal 
                          ? generateRules(paramContext, label, !isAgencyInmate)
                          : []
                      )
                    : []
                }
              >
                <TextField
                  inputType={htmlType}
                  type={htmlType}
                  placeholder={label}
                  disabled={disabled || !edit || !bookingsFieldsEnabled}
                  className={view ? "" : "input-control-mask"}
                />
              </FormItem>
            </>
          )}
          {htmlType === "select" && (
            <>
              <FormItem
                name={columnName}
                label={label}
                rules={
                  !fullSearch 
                    ? (
                        !isScheduledBookingLocal 
                          ? generateRules(paramContext, label, !isAgencyInmate)
                          : []
                      )
                    : []
                }
              >
                <Select
                  options={getOptionsFromRefList(
                    refListName || columnName,
                    isStaff ? true : false,
                    longStringRequired ? true : false,
                    isID ? true : false
                  )}
                  placeholder={label}
                  showSearch={showSearch}
                  variant="outlined"
                  disabled={
                    !bookingsFieldsEnabled || !edit || !bookingsFieldsEnabled
                  }
                  className={view ? "" : "input-control-mask"}
                ></Select>
              </FormItem>
            </>
          )}
          {htmlType === "datetime" && (
            <FormItem
              name={columnName}
              label={label}
              rules={
                  !fullSearch 
                    ? (
                        !isScheduledBookingLocal 
                          ? generateRules(paramContext, label, !isAgencyInmate)
                          : []
                      )
                    : []
                }
              initialValue={columnName === "arrestDateTime" ? "" : ""}
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                showTime={true}
                disableFutureDates={canSelectFutureDate}
                inputProps={{
                  maxLength: 16,
                }}
                disabled={
                  !bookingsFieldsEnabled || !edit || !bookingsFieldsEnabled
                }
                className={view ? "" : "input-control-mask"}
              />
            </FormItem>
          )}
          {htmlType === "date" && (
            <FormItem
              name={columnName}
              label={label}
              rules={
                  !fullSearch 
                    ? (
                        !isScheduledBookingLocal 
                          ? generateRules(paramContext, label, !isAgencyInmate)
                          : []
                      )
                    : []
                }
              initialValue={""}
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY"
                format="MM/DD/YYYY"
                showTime={false}
                isDOB={columnName === "dob"}
                disableFutureDates={columnName == "dob"}
                disablePastDate={disablePastDate}
                inputProps={{
                  maxLength: 10,
                }}
                disabled={
                  !bookingsFieldsEnabled || !edit || !bookingsFieldsEnabled
                }
                className={view ? "" : "input-control-mask"}
              />
            </FormItem>
          )}
          {htmlType === "checkbox" && (
            <StyledFlex align="center" style={{ height: "100%" }}>
              <FormItem
                name={columnName}
                valuePropName="checked"
                label={label}
                layout="horizontal"
                className="form-item-checkbox-left"
                style={{ marginBottom: "0" }}
              >
                <Checkbox
                  className={view ? "" : "input-control-mask"}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledFlex>
          )}
        </StyledColumn>
      }
    </React.Fragment>
  );
};

export default DynamicForm;
